import { render, staticRenderFns } from "./sliders.vue?vue&type=template&id=47f87fe9"
import script from "./sliders.vue?vue&type=script&lang=js"
export * from "./sliders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports